import api from '../../utils/axios';

export const appBookingService = {
  fetchBookings: async () => {
    const response = await api.get('/agent/bookings');
    return response.data;
  },
  getAppBookings: async () => {
    const response = await api.get('/agent/bookings');
    return response.data;
  }
};

export default appBookingService;

